import { useEffect, useState } from "react";
import axios from "axios";
import RendomTokenData from "./StoreToken";




const SiteUrl = "https://vipin.hyperofficial.in/";
const WebsiteAPIurl = SiteUrl + "api/";


const useBannerdata = () => {
    const RendomTokenfetch = RendomTokenData();
    const [sliderdata, setwebSetting] = useState({});
    
  useEffect(() => {
     if (RendomTokenfetch === null) return; 
   const Fetchwebsite = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}banners`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setwebSetting(res.data);
  } catch (err) {
  }
};
    Fetchwebsite();
  }, [RendomTokenfetch]);
  return [sliderdata];
};


/**** Banner End  */


/* =======Website Setting=========*/
const useWebsiteSetting = () => {
    const RendomTokenfetch = RendomTokenData();
      const [webSetting, setwebSetting] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const Fetchwebsite = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}websitesetting`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setwebSetting(res.data.data);
  } catch (err) {
  }
};
    Fetchwebsite();
  }, [RendomTokenfetch]);
  return [webSetting];
};


/************* Service Api  Start ***********/

/* =======Website Setting=========*/
const useServicedata = () => {
    const RendomTokenfetch = RendomTokenData();
      const [servicedata, setSectionservice] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetcServicesdata = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}services`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setSectionservice(res.data);
  } catch (err) {
  }
};
    FetcServicesdata();
  }, [RendomTokenfetch]);
  return [servicedata];
};

/************* Service Api  End ***********/

/*******Content data Api Start ****/

const useContentdata = () => {
    const RendomTokenfetch = RendomTokenData();
      const [contentdata, setContentdata] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetcContentdata = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}contents`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setContentdata(res.data);
  } catch (err) {
  }
};
    FetcContentdata();
  }, [RendomTokenfetch]);
  return [contentdata];
};


/*******Content data Api End*** */


/*******Why Choose data data Api Start ****/

const useWhyChoosedata = () => {
    const RendomTokenfetch = RendomTokenData();
      const [whyChoosedata, setWhyChoosedata] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetcWhyChoosedata = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}whychoose`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setWhyChoosedata(res.data);
  } catch (err) {
  }
};
    FetcWhyChoosedata();
  }, [RendomTokenfetch]);
  return [whyChoosedata];
};


/*******Why Choose data  Api End*** */


/*******Client data  Api Start*** */

const useClientdata = () => {
    const RendomTokenfetch = RendomTokenData();
      const [clientdata, setClientdata] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetcuClientdata = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}testimonials`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setClientdata(res.data);
  } catch (err) {
  }
};
    FetcuClientdata();
  }, [RendomTokenfetch]);
  return [clientdata];
};

/*******Client data  Api End*** */


/*******Blog data  Api Start*** */

const useBlogs = () => {
    const RendomTokenfetch = RendomTokenData();
      const [blogdata, setBlogdata] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetcuBlogdata = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}latest-blogs`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setBlogdata(res.data.data);
  } catch (err) {
  }
};
    FetcuBlogdata();
  }, [RendomTokenfetch]);
  return [blogdata];
};

/*******Blog data  Api End*** */



/*******Language data  Api Start*** */

const useLanguagedata = () => {
    const RendomTokenfetch = RendomTokenData();
      const [languagedata, setLanguagedata] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const Fetchlanguagedata = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}languages`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setLanguagedata(res.data);
  } catch (err) {
  }
};
    Fetchlanguagedata();
  }, [RendomTokenfetch]);
  return [languagedata];
};
/*******Language  data  Api Start*** */

/*******Blog data  Api Start*** */

const useBlogdata_bylang = (language) => {
    const RendomTokenfetch = RendomTokenData();
      const [blogdatalang, setBlogdatalang] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetcuBlogdatalang = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}blogs-by-language`,{
        langcat : language,
      },
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setBlogdatalang(res.data.data);
  } catch (err) {
  }
};
    FetcuBlogdatalang();
  }, [RendomTokenfetch,language]);
  return [blogdatalang];
};

/*******Blog data  Api End*** */

/********Use Cat Data Meta Tag Start  ***** */
const useCatmetaTags = (language) => {
    const RendomTokenfetch = RendomTokenData();
      const [catmetaTags, setcatmetatag] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const Fetchcatmetatag = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}language-detail`,{
         langcat : language,
      },
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setcatmetatag(res.data);
  } catch (err) {
  }
};
    Fetchcatmetatag();
  }, [RendomTokenfetch,language]);
  return [catmetaTags];
};

/********Use Cat Data Meta Tag End  ***** */



/********Page Meta Data Start  ***** */
const usePagemetaTags = () => {
    const RendomTokenfetch = RendomTokenData();
      const [pagemetaTags, setpagemetadata] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const FetchpagemetaTags = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}pagemetatag`,{},
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setpagemetadata(res.data);
  } catch (err) {
  }
};
    FetchpagemetaTags();
  }, [RendomTokenfetch]);
  return [pagemetaTags];
};

/******** Page Meta Data  End  ***** */



/********Use Cat Data Meta Tag Start  ***** */
const useBlogdetails = (slugname) => {
    const RendomTokenfetch = RendomTokenData();
      const [blogdetails, setblogdetails] = useState([]);
  useEffect(() => {
      if (RendomTokenfetch === null) return;
   const Fetchblogdetails = async () => {
  try {
    const res = await axios.post(
      `${WebsiteAPIurl}blog-by-slug`,{
         slugname : slugname,
      },
      {
        headers: {
          Authorization: RendomTokenfetch,
        },
      }
    );
      setblogdetails(res.data.data);
  } catch (err) {
  }
};
    Fetchblogdetails();
  }, [RendomTokenfetch,slugname]);
  return [blogdetails];
};

/********Use Cat Data Meta Tag End  ***** */




export default useWebsiteSetting ;
export {
    useBannerdata,
    useServicedata,
    useContentdata,
    useWhyChoosedata,
    useClientdata,
    useBlogs,
    useLanguagedata,
    useBlogdata_bylang,
    useCatmetaTags,
    usePagemetaTags,
    useBlogdetails,
};
